var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.66667C2 4.43248 5.43248 1 9.66667 1C13.9008 1 17.3333 4.43248 17.3333 8.66667C17.3333 13.8417 10.625 19.6875 10.2896 19.9367C9.93095 20.2434 9.40238 20.2434 9.04375 19.9367L9.04215 19.9353C8.73221 19.6667 2 13.8325 2 8.66667ZM3.91685 8.6665C3.91685 11.8673 7.6256 15.9978 9.66685 17.9144C11.7081 16.0073 15.4169 11.8673 15.4169 8.6665C15.4169 5.49087 12.8425 2.9165 9.66685 2.9165C6.49122 2.9165 3.91685 5.49087 3.91685 8.6665ZM9.66634 4.83336C7.54925 4.83336 5.83301 6.5496 5.83301 8.66669C5.83301 10.7838 7.54925 12.5 9.66634 12.5C11.7834 12.5 13.4997 10.7838 13.4997 8.66669C13.4997 7.65003 13.0958 6.675 12.3769 5.95611C11.658 5.23722 10.683 4.83336 9.66634 4.83336ZM7.74986 8.66653C7.74986 9.72507 8.60798 10.5832 9.66653 10.5832C10.7251 10.5832 11.5832 9.72507 11.5832 8.66653C11.5832 7.60798 10.7251 6.74986 9.66653 6.74986C8.60798 6.74986 7.74986 7.60798 7.74986 8.66653Z",
    fill: "#32AE78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.88c10720c9a0acbe4083e4504990f220.svg";
export { ForwardRef as ReactComponent };